__turbopack_context__.v({
  "blogItem": "gvMWBa_blogItem",
  "calculator": "gvMWBa_calculator",
  "calculatorPane": "gvMWBa_calculatorPane",
  "calculatorSection": "gvMWBa_calculatorSection",
  "calculatorTitle": "gvMWBa_calculatorTitle",
  "content": "gvMWBa_content",
  "footnote": "gvMWBa_footnote",
  "isBlog": "gvMWBa_isBlog",
  "paddingBottom0": "gvMWBa_paddingBottom0",
  "paddingBottom112": "gvMWBa_paddingBottom112",
  "paddingBottom128": "gvMWBa_paddingBottom128",
  "paddingBottom16": "gvMWBa_paddingBottom16",
  "paddingBottom32": "gvMWBa_paddingBottom32",
  "paddingBottom48": "gvMWBa_paddingBottom48",
  "paddingBottom64": "gvMWBa_paddingBottom64",
  "paddingBottom80": "gvMWBa_paddingBottom80",
  "paddingBottom96": "gvMWBa_paddingBottom96",
  "paddingTop0": "gvMWBa_paddingTop0",
  "paddingTop112": "gvMWBa_paddingTop112",
  "paddingTop128": "gvMWBa_paddingTop128",
  "paddingTop16": "gvMWBa_paddingTop16",
  "paddingTop32": "gvMWBa_paddingTop32",
  "paddingTop48": "gvMWBa_paddingTop48",
  "paddingTop64": "gvMWBa_paddingTop64",
  "paddingTop80": "gvMWBa_paddingTop80",
  "paddingTop96": "gvMWBa_paddingTop96",
  "text": "gvMWBa_text",
});
